import { StrictMode, Component, type ReactNode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./api/queries";
import App from "./App";
import { Dialogos } from "./components/Dialogos";
import { Avisos } from "./components/Avisos";
import "./styles.css";
// Opción B: toda la app con el estilo del paso 2 nuevo.
import "./estilo-nuevo.css";
// Celular: va al final para mandar sobre las demás capas.
import "./movil.css";
class ErrorBoundary extends Component<
  { children: ReactNode },
  { error: boolean }
> {
  state = { error: false };
  static getDerivedStateFromError() {
    return { error: true };
  }
  render() {
    return this.state.error ? (
      <main className="card error-pantalla" role="alert">
        <h1>No se pudo mostrar el cotizador</h1>
        <p>
          Ocurrió un error inesperado. Recarga la página para volver a
          intentarlo.
        </p>
        <button className="primary" onClick={() => location.reload()}>
          Recargar
        </button>
      </main>
    ) : (
      this.props.children
    );
  }
}
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <Avisos>
          <Dialogos>
            <App />
          </Dialogos>
        </Avisos>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
